const TRANSITION_MS = 350;

const openItem = (article, trigger, body) =>
{
    trigger.setAttribute('aria-expanded', 'true');
    article.classList.add('open');

    // animate from the current height (0) up to the content height
    body.style.height = `${body.scrollHeight}px`;

    const onEnd = (ev) =>
    {
        if (ev.target !== body || ev.propertyName !== 'height')
        {
            return;
        }

        // let the panel grow/shrink naturally (responsive reflow) while open
        if (article.classList.contains('open'))
        {
            body.style.height = 'auto';
        }

        body.removeEventListener('transitionend', onEnd);
    };

    body.addEventListener('transitionend', onEnd);
};

const closeItem = (article, trigger, body) =>
{
    // pin the current height in px so we have a value to animate down from
    body.style.height = `${body.scrollHeight}px`;
    // force a reflow so the browser registers the explicit height before collapsing
    body.offsetHeight;

    trigger.setAttribute('aria-expanded', 'false');
    article.classList.remove('open');

    body.style.height = '0px';
};

export const initFaq = () =>
{
    document.querySelectorAll('.content-block[data-type="faq"] ul.faq-list').forEach(list =>
    {
        const items = Array.from(list.querySelectorAll('article[data-faq]')).map(article => ({
            article,
            trigger: article.querySelector('.faq-trigger'),
            body: article.querySelector('.body'),
        })).filter(item => item.trigger && item.body);

        items.forEach(item =>
        {
            item.trigger.addEventListener('click', () =>
            {
                const isOpen = item.trigger.getAttribute('aria-expanded') === 'true';

                if (isOpen)
                {
                    closeItem(item.article, item.trigger, item.body);
                    return;
                }

                // one at a time — collapse any other open item in this list
                items.forEach(other =>
                {
                    if (other !== item && other.trigger.getAttribute('aria-expanded') === 'true')
                    {
                        closeItem(other.article, other.trigger, other.body);
                    }
                });

                openItem(item.article, item.trigger, item.body);
            });
        });
    });
};
